const findInputContainer = (element) => {
  if (!document) return null;
  let parent = element.parentNode;
  while (parent !== null && parent !== document.body) {
    if (parent.className && parent.className.match(/SelectField__control/))
      return parent;
    parent = parent.parentNode;
  }
  return element;
};

/**
 * @deprecated
 * Sets the parent container position when scrolling
 * @returns
 */
const fixDropDownPositionMobile = () => {
  const menu = document.querySelector(".SelectField__menu");

  if (typeof window === "undefined" || !menu) return;

  const parent = menu.parentNode;
  const parentStyle = window.getComputedStyle(menu.parentElement);

  if (parentStyle.position !== "fixed") return;
  if (!parent || document.activeElement === document.body) return;
  const container = findInputContainer(document.activeElement);
  const offsetTop = 8;
  const inputRect = container.getBoundingClientRect();
  const top = inputRect.top + offsetTop + container.clientHeight;
  const left = inputRect.left;

  if (parent) {
    parent.style.top = `${top}px`;
    parent.style.left = `${left}px`;
  }
};

export default fixDropDownPositionMobile;
